import { render, staticRenderFns } from "./CustomerOrder.vue?vue&type=template&id=771550a2&scoped=true"
import script from "./CustomerOrder.vue?vue&type=script&lang=js"
export * from "./CustomerOrder.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CustomerOrder.vue?vue&type=style&index=1&id=771550a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771550a2",
  null
  
)

export default component.exports